import {
  dedereCompanyIds
} from 'application/src/js/globals.js';

import {
  Mediator
} from 'application/src/js/util.js';

/**
 * @description Controller class for the top instersted companies list
 * @param {Mediator} args.mediator Mediator instance
 * @param {DataStorage} args.store DataStorage instance
 * @param {object} args.translations text translations
 * @param {Pagination} args.pagination Pagination instance
 * @param {TopInterestedDetailsModal} args.topInterestedDetailsModal TopInterestedDetailsModal instance
 */
export default class TopInterestedList extends Mediator {
  constructor(args) {
    super(args);

    this.mediator = args.mediator;
    this.store = args.store;
    this.translations = args.translations;
    this.pagination = args.pagination;
    this.topInterestedDetailsModal = args.topInterestedDetailsModal;

    this.outerContainer = document.querySelector('.top-interested-list');
    this.exportButton = document.querySelector('.clicks-list .export-file');
    this.listContentElement = this.outerContainer.querySelector('.list-content');
    this.listHead = this.outerContainer.querySelector('.list-head');
    this.sortTrigger = this.listHead.querySelectorAll('[data-sort]');

    this.hideClass = 'hide';
    this.sortField = 'clicks';
    this.sortDir = 'desc';
    this.perPage = 15;
    this.pageIndex = 0;

    this.addEvents();
  }

  addEvents() {
    ['init', 'update'].map(eventType => {
      this.store.subscribe(eventType, e => {
        this.data = Object.assign({}, e.topInterested);
        this.pageIndex = this.pagination.update(this.data.companies.length, this.perPage);
        this.listContentElement.classList[this.data.companies.length ? 'remove' : 'add'](this.hideClass);
        this.render();
      });
    });

    Array.prototype.slice.call(this.sortTrigger).map(trigger => {
      trigger.addEventListener('click', e => {
        const prevTrigger = this.listHead.querySelector(`[data-sort="${this.sortField}"]`);
        prevTrigger.classList.remove(this.sortDir);

        if (trigger.isEqualNode(prevTrigger)) {
          this.sortDir = this.sortDir == 'desc' ? 'asc' : 'desc';
        } else {
          this.sortDir = 'desc';
          prevTrigger.classList.remove('sort');
          trigger.classList.add('sort');
        }

        trigger.classList.add(this.sortDir);
        this.sortField = trigger.getAttribute('data-sort');

        this.render();
      });
    });

    this.pagination.subscribe('pageChange', pageIndex => {
      this.pageIndex = pageIndex;
      if (window.pageYOffset > this.outerContainer.offsetTop) {
        this.outerContainer.scrollIntoView();
      }
    });
  }

  sortList(companies) {
    if (this.sortDir == 'desc') {
      switch (this.sortField) {
        case 'clicks':
          return companies.sort((a, b) => {
            return b.amount - a.amount;
          });
        case 'country':
          return companies.sort((a, b) => {
            return a.country_name.toLowerCase() < b.country_name.toLowerCase() ? 1 : -1;
          });
        case 'company':
          return companies.sort((a, b) => {
            return a.name.toLowerCase() < b.name.toLowerCase() ? 1 : -1;
          });
        case 'global_value_added_step_name':
          return companies.sort((a, b) => {
            if (a.global_value_added_step_name === b.global_value_added_step_name) {
              return 0;
            } else if (a.global_value_added_step_name === null) {
              return 1;
            } else if (b.global_value_added_step_name === null) {
              return -1;
            } else {
              return a.global_value_added_step_name.toLowerCase() < b.global_value_added_step_name.toLowerCase() ? 1 : -1;
            }
          });
      }
    } else {
      switch (this.sortField) {
        case 'clicks':
          return companies.sort((a, b) => {
            return a.amount - b.amount;
          });
        case 'country':
          return companies.sort((a, b) => {
            return a.country_name.toLowerCase() > b.country_name.toLowerCase() ? 1 : -1;
          });
        case 'company':
          return companies.sort((a, b) => {
            return a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1;
          });
        case 'global_value_added_step_name':
          return companies.sort((a, b) => {
            if (a.global_value_added_step_name === b.global_value_added_step_name) {
              return 0;
            } else if (a.global_value_added_step_name === null) {
              return -1;
            } else if (b.global_value_added_step_name === null) {
              return 1;
            } else {
              return a.global_value_added_step_name.toLowerCase() > b.global_value_added_step_name.toLowerCase() ? 1 : -1;
            }

          });
      }
    }
  }

  render() {
    this.listContentElement.innerHTML = '';

    this.sortList(this.data.companies).map(clicksRowData => {
      const rowElement = document.createElement('div');
      this.listContentElement.insertAdjacentElement('beforeend', rowElement)

      new ClicksRow({
        parent: this,
        mediator: this.mediator,
        translations: this.translations,
        element: rowElement,
        data: clicksRowData,
        store: this.store,
        topInterestedDetailsModal: this.topInterestedDetailsModal
      });
    });
  }

  showDetails(companyId, companyName, addressId) {
    if (!this.topInterestedDetailsModal) return;

    const state = this.store.getState();

    this.topInterestedDetailsModal.show({
      company_id: companyId,
      start_date: state.start_date,
      end_date: state.end_date,
      products: Object.keys(state.products)
    }, companyName, addressId);
  }
}

class ClicksRow {
  constructor(args) {
    this.parent = args.parent;
    this.mediator = args.mediator;
    this.translations = args.translations;
    this.element = args.element;
    this.data = args.data;
    this.store = args.store;
    this.topInterestedDetails = args.topInterestedDetails;

    this.render();
  }

  render() {
    this.element.innerHTML = this.template;
    this.element.classList.add('list-row');
    this.showDetailsButton = this.element.querySelector('.show-details');
    this.showNotesButton = this.element.querySelector('.show-notes');

    this.addEvents();
  }

  addEvents() {
    if (this.showDetailsButton) {
      this.showDetailsButton.addEventListener('click', e => this.parent.showDetails(this.data.company_id, this.data.name, this.data.global_address_id));
    }

    if (this.showNotesButton) {
      this.showNotesButton.addEventListener('click', e => {
        this.mediator.publish('showNotes', this.data.global_address_id, this.data.name);

        import( /* webpackChunkName: "manage-user-notes" */ 'application/src/js/user-notes/manage-user-notes.js')
          .then(({ default: ManageUserNotesController }) => {
            const manageUserNotesController = new ManageUserNotesController({
              isModal: true,
              subHeadline: this.data.name
            });
            manageUserNotesController.modal.subscribe('open', this.mediator.publish('showNotes'));
            manageUserNotesController.modal.subscribe('close', this.mediator.publish('hideNotes'));
            manageUserNotesController.load(this.data.global_address_id);
          });
      });
    }
  }

  get isDedere() {
    const state = this.store.getState();
    return state.user && dedereCompanyIds.includes(state.user.company_id);
  }

  get canAccessDetails() {
    return this.data.name ? this.data.name.indexOf('* *') === -1 : true;
  }

  get clicksColumn() {
    return `
      <div class="clicks">
        <span>${this.data.amount}</span>
        <span class="clicks-label">${this.translations[this.data.amount > 1 ? `clicks` : `click`]}</span>
      </div>
    `;
  }

  get companyColumn() {
    if (this.canAccessDetails) {
      return this.data.name ? `
        <div class="company">
          ${this.data.global_address_id ? `
            <a href="/mundus-agri/addressDetails/${this.data.global_address_id}" title="${this.translations.goToCompany}">
              ${this.data.name}
            </a>
          ` : this.data.name}
        </div>` : `<div class="empty"></div>`;
    } else {
      return `<div class="company"><span class="no-access">${this.data.name || '* * * * *'}</span></div>`;
    }
  }

  get vasColumn() {
    return this.translations.valueAddedSteps[this.data.global_value_added_step_id] ? `<div class="company">${this.translations.valueAddedSteps[this.data.global_value_added_step_id]}</div>` : `<div class="empty"></div>`;
  }

  get countryColumn() {
    return this.data.country_name && this.data.country_short ? `
      <div class="country">
        <div>
          <img src="/projects/application/dist/images/icons/flags/4x3/${this.data.country_short.toLowerCase()}.svg" alt="${this.data.country_name}" title="${this.data.country_name}"> <span>${this.data.country_name}</span>
        </div>
      </div>
    ` : `<div class="empty"></div>`;
  }

  get buttonColumn() {
    return `
      <div class="action">
        <div>
          ${this.canAccessDetails ? `
            <a class="show-notes">${this.translations.notes}</a>
          ` : ''}

          ${this.isDedere ? `
            <a class="show-details">${this.translations.details}</a>
          ` : ''}
        </div>
      </div>
    `;
  }

  get template() {
    return `
      ${this.clicksColumn}
      ${this.companyColumn}
      ${this.countryColumn}
      ${this.vasColumn}
      ${this.buttonColumn}
    `;
  }
}